<template>
  <o-dialog
    ref="dialog"
    :title="$t('service.addService')"
    :info="$t('components.order.actions.addService.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('service.addService'), type: 'confirm', callback: confirm },
    ]"
    :loading="loading"
    :portal="portal"
    :valid="validate"
  >
    <div class="pt-4 text-left">
      <o-form ref="form">
        <o-field-group v-slot="{ status }" :label="$t('general.service')" class="w-full mb-6" rules="required">
          <service-select
            v-model="service"
            class="w-full"
            :status="status"
          />
        </o-field-group>

        <o-field-group :label="$t('general.employee')" class="w-full mt-6 block">
          <employee-select
            v-model="employee"
            :types="['employee']"
            class="w-full"
            :filter="employeeFilter"
            :disabled="!service"
            allow-none
          />
        </o-field-group>
      </o-form>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import EmployeeSelect from '@/components/employee/elements/Select.vue'
import ServiceSelect from '@/components/service/elements/Select.vue'

interface Props {
  order: Record<string, any>
  portal?: string
  loading?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<{
  'update:loading': [value: boolean]
  'update:order': [value: any]
}>()

const { $api, $notification, $i18n } = useNuxtApp()

const dialog = ref<any>(null)
const form = ref<any>(null)

const service = ref<any>(null)
const employee = ref<any>(null)

function open() {
  dialog.value.open()
}

async function confirm() {
  emit('update:loading', true)

  try {
    const svc = service.value
    const emp = employee.value
    const response = await $api.order.addService(String(props.order.idOrder), {
      serviceId: String(svc.idService),
      employeeId: emp?.idEmployee ? String(emp.idEmployee) : undefined,
    })
    const order = response.data

    emit('update:order', order)

    $notification.toast({
      title: $i18n.t('components.order.actions.addService.success'),
      text: $i18n.t('components.order.actions.addService.successInfo'),
      variant: 'success',
    })

    service.value = null
    employee.value = null

    emit('update:loading', false)

    return true
  } catch (e) {
    console.log(e)
  }

  emit('update:loading', false)
}

function validate() {
  return form.value.validate()
}

function employeeFilter(emp: any) {
  const svc = service.value
  return svc && svc.employeeIDs ? svc.employeeIDs.includes(emp.idEmployee) : false
}

defineExpose({ open })
</script>
